<app-draggable-modal-wrapper>
    <h2
        mat-dialog-title
        modal-drag-handle
        class="!text-2xl !font-normal !text-primary-700 !mb-2"
    >
        Authorize.NET Transaction Details
    </h2>
    <hr />
    <mat-dialog-content class="ps-6 pt-2 mat-typography">
        <div class="rounded-lg border border-slate-200 bg-slate-50 p-4 mt-2">
            <p class="text-sm text-slate-600 mb-4">
                Review the response provided by the payment provider below.
            </p>

            <div class="grid grid-cols-1 gap-4">
                <div
                    class="bg-white rounded-md border border-slate-200 px-4 py-3"
                >
                    <p
                        class="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1"
                    >
                        Description
                    </p>
                    <p
                        class="text-sm text-slate-800 whitespace-pre-wrap break-words"
                    >
                        {{ response.description }}
                    </p>
                </div>

                <div
                    class="bg-white rounded-md border border-slate-200 px-4 py-3"
                >
                    <p
                        class="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1"
                    >
                        AVS Response
                    </p>
                    <p class="text-sm text-slate-800 break-words">
                        {{ avsResponseLabel }}
                    </p>
                </div>

                <div
                    class="bg-white rounded-md border border-slate-200 px-4 py-3"
                >
                    <p
                        class="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1"
                    >
                        CVV Response
                    </p>
                    <p class="text-sm text-slate-800 break-words">
                        {{ cvvResponseLabel }}
                    </p>
                </div>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="!pb-5 !pr-5">
        <button
            type="button"
            mat-stroked-button
            color="primary"
            class="!border-primary-700"
            (click)="close()"
        >
            Close
        </button>
    </mat-dialog-actions>
</app-draggable-modal-wrapper>
